<template>
    <div class="bg-tertiary-100 font-roboto text-tertiary-700 px-2 py-1 rounded-md">

        {{ bicycleCode }}

    </div>
</template>

<script lang="ts" setup>
const { bicycleCode } = defineProps({
    bicycleCode: {
        type: String,
        required: true
    }
})


</script>
